// Hooks
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Actions
import H2 from '@/components/base/Headings/H2';
import Icon from '@/components/base/Icon';
import NotificationsCounter from '@/components/base/NotificationsCounter';

const HeaderNotifications = () => {
    const { t } = useTranslation();
    const { unreadNotifications, hasUnreadNotifications } = useToastsNotifications({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return (
        <header className="z-10 mb-5 pb-5">
            <H2 className="relative inline-flex items-center">
                <Icon icon="notification" className="mr-3 text-xl text-icoBlue" />
                <span>{t('notifications:title')}</span>
                {hasUnreadNotifications ? (
                    <NotificationsCounter className="absolute -right-5 -top-2.5 flex items-center justify-center">
                        {unreadNotifications}
                    </NotificationsCounter>
                ) : null}
            </H2>
        </header>
    );
};

export default HeaderNotifications;
